import { api } from './api';

export async function fetchStats(params) {
  const query = Object.keys(params).map((key) => key + '=' + params[key])
  const apiInst = await api()

  const response = await apiInst.get('roles?not_position=goalie&include=stats&type=player,player_cross_region_registration,player_cross_registration,player_recreational&' + query.join('&'))
  return response.data
}

export async function fetchGoalieStats(params) {
  const query = Object.keys(params).map((key) => key + '=' + params[key])
  const apiInst = await api()
  const url = 'roles?position=goalie&include=team,stats.goalkeeper&type=player,player_cross_region_registration,player_cross_registration,player_recreational&' + query.join('&')
  const response = await apiInst.get(url)

  return response.data
}
